<template>
    <div class="add_stored_value">
        <div>
            <div class="buttons">
                <input class="store_amount" type="number" v-model.number="store_amount" placeholder="請輸入儲值金額">
                <button @click="produce(store_amount)">
                    產生儲值繳費碼
                </button>
            </div>
            <hr>
            <div class="table_list">
                <div class="list_title">
                    <h3>儲值紀錄</h3>
                </div>
                <button class="cancel_style" @click="cancel">
                    返回
                </button>
                <table class="table" ref="oTable">
                    <thead>
                        <tr>
                            <th>儲值日期</th>
                            <th>儲值金額</th>
                            <th>付款帳號</th>
                            <!-- <th>已付金額</th>
                            <th>聯絡人</th>
                            <th>連絡電話</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-show="stored_value_list.length > 0" v-for="item in stored_value_list" :key="item.id">
                            <td>{{item.payment_time}}</td>
                            <td>{{item.stored_value_amount}}</td>
                            <td>{{item.emergency_phone}}</td>
                            <!-- <td>{{item.actual_payment_amount}}</td>
                            <td>{{item.emergency_contact}}</td>
                            <td>{{item.emergency_phone}}</td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "@/assets/css/member/addStoredValue.css";

export default {
    name: 'AddStoredValue',
    data() {
        return {
            store_amount: '',
            stored_value_list: '',
        };
    },
    components: {

    },
    filters: {},
    beforeMount: function () {
        const getData = new FormData();
        getData.append('CMD', 'FrontMemberHomeAddStoredValue');
        getData.append('house_number', localStorage.getItem('house_number'))
        this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, getData)
        .then(response => {
            // console.log(response);
            const get_data = response.data.stored_value_list;
            if (get_data) {
                this.stored_value_list = get_data;
                this.$nextTick(() =>{ //請求成功的回調使用
                    $(this.$refs.oTable).DataTable({
                        searching: false, //搜尋功能, 預設是開啟
                        paging: true, //分頁功能, 預設是開啟
                        ordering: false, //排序功能, 預設是開啟
                        lengthMenu: [10, 20],
                        language: {
                            processing: "處理中...",
                            loadingRecords: "載入中...",
                            lengthMenu: "一頁顯示 _MENU_ 筆",
                            zeroRecords: "沒有數據....",
                            info: "第 _START_ ~ _END_ 筆，共 _TOTAL_ 筆",
                            infoEmpty: "",
                            infoFiltered: "(從 _MAX_ 項結果中過濾)",
                            infoPostFix: "",
                            search: "搜尋:",
                            paginate: {
                                first: "第一頁",
                                previous: "上一頁",
                                next: "下一頁",
                                last: "最後一頁"
                            }
                        }
                    });
                })
            } else {
                console.log(response.data.error);
                this.$nextTick(() =>{ //請求成功的回調使用
                    $(this.$refs.oTable).DataTable({
                        searching: false, //搜尋功能, 預設是開啟
                        paging: true, //分頁功能, 預設是開啟
                        ordering: false, //排序功能, 預設是開啟
                        lengthMenu: [10, 20],
                        language: {
                            processing: "處理中...",
                            loadingRecords: "載入中...",
                            lengthMenu: "一頁顯示 _MENU_ 筆",
                            zeroRecords: "沒有數據....",
                            info: "第 _START_ ~ _END_ 筆，共 _TOTAL_ 筆",
                            infoEmpty: "",
                            infoFiltered: "(從 _MAX_ 項結果中過濾)",
                            infoPostFix: "",
                            search: "搜尋:",
                            paginate: {
                                first: "第一頁",
                                previous: "上一頁",
                                next: "下一頁",
                                last: "最後一頁"
                            }
                        }
                    });
                })
            }
        })
        .catch(error => {
            console.log(error);
        })
    },
    methods: {
        cancel () {
            this.$router.push({ name: 'MemberHome'});
        },
        produce (store_amount) {
            if (store_amount == '') {
                alert('請輸入儲值金額');
            } else {
                console.log(store_amount);
                alert('開發中');
            }

        }
    },
    mounted: function () {

    },
    watch: {
        // store_amount (e) {
        //     console.log(typeof(e))
        // }
    },
    beforeDestroy : function () {
        $('#datatable').DataTable({
            destroy: true
        });
    }
};
</script>

<style>

</style>
